import { combineReducers } from 'redux'

import {reducer as notifications} from 'lib/api/notifications'
import {localeReducer as locale} from 'data/reducers/locale'

export const rootReducer = combineReducers({
  // app-specific reducers:
  // rwgps api reducers:
  notifications,
  locale
})
